import $api from "@/api/jobs.js";
import {getCookie, getCookies} from '@/tools/cookie';
import {stateOptions} from '@/tools/formData.js';
import mixpanel from '@/utils/mixpanel.js';
export default {
  data() {
    return {
      jobList: [],
      loadedJobsLists: [],
      more: true,
      loading: true,
      total: 0,
      query: {
        keywords: '',
        state: '',
        pageSize: 5,
        page: 0,
        tagOne: '',
        tagTwo: '',
        tagThree: ''
      },
      state: {
        label: 'All States',
        value: 'All States'
      },
      display: true,
      contenHeight: 700,
      icons: [
        {
          src: require('@/assets/icon/ic_location.svg'),
          alt: "icon-view-poi"
        },
        {
          src: require('@/assets/icon/ic-jobs-empty-state.svg'),
          alt: "empty-state"
        }
      ],
      preference: {

      }
    }
  },
  methods: {
    init() {
      this.query = {
        state: '',
        location: '',
        pageSize: 5,
        page: 0
      };
    },
    async load() {
      // 只在loading为false时触发，防止在请求数据过程中多次触发
      if (!this.loading && this.more) {
        this.loading = true
        this.query.page++
        await this.search('turnPage')
        this.loading = false
      }
    },
    async search(type='search') {
      if (this.query.state === 'All States') {
        this.query.state = "";
      }
      this.loading = true;
      const query = this.query;
      const preference = this.preference;
      // preference和query的顺序不能颠倒
      const params = Object.assign({}, preference, query);
      const [err, res] = await $api.getJobs(params);
      this.loading = false;
      if (!err) {
        // 如果是根据条件进行搜索，那么本次搜索会清除上一次的结果。
        // 如果是滑动到底部进行翻页，那么展示的结果应该是上一次的结果加上本次的搜索结果。
        const loadedJobsLists = type === 'search' ? [] : this.loadedJobsLists
        this.jobList = this.formatJobList(res.data.data.resultList);
        this.loadedJobsLists = loadedJobsLists.concat(this.jobList);
        this.total = res.data.data.total;
        this.more = res.data.data.more;
      } else {
        console.log('fail to get load jobs');
      }
    },
    formatJobList(list) {
      // 对于没有的字段，可设置默认值。
      if (list && list.length > 0) {
        return list.map(elem => elem);
      }
      return [];
    },
    filter(state) {
      this.query.page = 0;
      this.query.state = state;
      this.display = true;
      this.loadedJobsLists = [];
      const target = stateOptions.find(elem => elem.value === state);
      if (target) {
        this.state = target;
      } else {
        this.state = {
          label: 'All States',
          value: 'All States'
        }
      }
      this.search()
    },
    currentLocation() {
      const that = this;
      const longitude = getCookie('longitude') || -1;
      const latitude = getCookie('latitude') || -1;
      if (longitude === -1 && latitude === -1) {
        that.filter();
        return;
      }
      $api.resolveLocation(longitude, latitude).then(res => {
        that.state = res;
        that.filter(that.state.value);
      },() => {
        that.state = {
          label: 'All States',
          value: 'All States'
        }
        that.filter();
      }).catch(() => {
        that.state = {
          label: 'All States',
          value: 'All States'
        }
        that.filter();
      })
    },
    resolveUrlParams() {
      // 解析地址栏里的搜索条件
      const search = window.location.href;
      const start = search.indexOf('?');
      const params = search.substring(start+1);
      const querys = params.split('&');
      querys.forEach(elem => {
        if (elem.indexOf('keywords') > -1) {
          let index = elem.indexOf('keywords');
          this.query.keywords = elem.slice(index + 9);
        }
        if (elem.indexOf('state') > -1) {
          let index = elem.indexOf('state');
          this.query.state = elem.slice(index + 6);
        }
        if (elem.indexOf('tagOne') > -1) {
          let index = elem.indexOf('tagOne');
          this.query.tagOne = elem.slice(index + 7);
        }
        if (elem.indexOf('tagTwo') > -1) {
          let index = elem.indexOf('tagTwo');
          this.query.tagTwo = elem.slice(index + 7);
        }
        if (elem.indexOf('tagThree') > -1) {
          let index = elem.indexOf('tagThree');
          this.query.tagThree = elem.slice(index + 9);
        }
      });
      const state = this.query.state.toUpperCase();
      const temp = stateOptions.find(elem => elem.value === state);
      if (temp) {
        this.state = temp;
      } else {
        this.state = {
          label: 'All States',
          value: 'All States'
        }
      }
      this.query.state = this.state.value;
      this.search();
    },
    keywordSearch(value) {
      this.loadedJobsLists = [];
      this.query.page = 0;
      this.query.keywords = value;
      this.display = true;
      this.search();
    },
    switchFilter() {
      const filter = this.$refs.mobileFilter;
      if (filter) {
        filter.drawer = true;
        this.display = false;
        mixpanel.track('Discover Page', {
          'Outcome': 'Click on Filter'
        })
      }
    },
    saveInfo(data) {
      if(Object.keys(data).length === 0) return;
      const distinct = getCookie('distinct-id');
      const latitude = getCookie('latitude');
      const longitude = getCookie('longitude');
      const driverToken = getCookie('driver-token');
      this.preference = Object.assign({
        distinct,
        driverToken,
        latitude,
        longitude
      }, data);
      // 不能删除，否则用户偏好数据中的state信息丢失
      this.query.state = data.state ? data.state : null;
      this.state = data.state ? stateOptions.find(elem => elem.value === data.state) : {label: 'All States', value: 'All States'}
      // 当用户填写完偏好数据之后请求
      if (this.state.value === 'All States') {
        this.currentLocation();
      } else {
        this.search();
      }
    }
  },
  created() {
    const {userId, distinct, deviceId, version} = getCookies();
    mixpanel.initMixpanel(process.env['VUE_APP_MIX_KEY']);
    mixpanel.identify(distinct);
    mixpanel.register({
      'Distinct ID': distinct, //公共参数
      'Device ID': deviceId,  //公共参数
      'User ID': userId,
      'App Version': version
    });
  },
  mounted() {
    this.resolveUrlParams();
  }
}
